import { render, staticRenderFns } from "./IrrigationManage.vue?vue&type=template&id=65b65eee&scoped=true"
import script from "./IrrigationManage.vue?vue&type=script&lang=js"
export * from "./IrrigationManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b65eee",
  null
  
)

export default component.exports